export type FeatureReleaseMode = 'ALL' | 'SELECTED' | 'OFF';

export type FeatureRelease = {
  key: string;
  label: string;
  description: string;
  pages: string[];
  employeePages: string[];
  adminPages: string[];
  mode: FeatureReleaseMode;
  personIds: string[];
  version: number;
  updatedAt?: string;
  updatedBy?: string;
};

export type FeatureReleaseInput = Pick<FeatureRelease, 'mode' | 'personIds' | 'version'>;

export type FeatureReleaseUser = {
  personId: string;
  identityId: string;
  displayName: string;
  workerNumber: string;
  organization: string;
  eligible: boolean;
  activeIdentityCount: number;
};

export type FeatureReleaseAccess = {
  key: string;
  label: string;
  available: boolean;
  reason: string;
  mode: FeatureReleaseMode;
};

export type FeatureReleaseHistoryItem = {
  id: string;
  changedAt: string;
  changedBy: string;
  previousMode: FeatureReleaseMode;
  mode: FeatureReleaseMode;
  addedPersonIds: string[];
  removedPersonIds: string[];
  version: number;
};

export const featureReleaseModeLabels: Record<FeatureReleaseMode, string> = {
  ALL: '전체 공개', SELECTED: '선택 사용자', OFF: '비공개',
};

export function featureReleaseAccessReason(access: FeatureReleaseAccess): string {
  const labels: Record<string, string> = {
    ADMIN_ONLY: '관리자 전용', AVAILABLE: '사용 가능', OFF: '앱 비공개', NOT_SELECTED: '공개 대상 아님',
    NO_PERMISSION: '업무 권한 없음', INELIGIBLE: '사용할 수 없는 계정', MULTIPLE_ACCOUNTS: '확인 필요',
  };
  return labels[access.reason] ?? (access.available ? '사용 가능' : '사용할 수 없음');
}

export function releaseTargetChanges(previous: readonly string[], next: readonly string[]) {
  const before = new Set(previous);
  const after = new Set(next);
  return {
    added: [...after].filter((id) => !before.has(id)),
    removed: [...before].filter((id) => !after.has(id)),
  };
}

export function isEmployeeApp(feature: FeatureRelease): boolean {
  return feature.employeePages.length > 0;
}

export function appReleaseLabel(feature: FeatureRelease): string {
  return isEmployeeApp(feature) ? featureReleaseModeLabels[feature.mode] : '관리자 전용';
}
